/* eslint-disable */
// @ts-nocheck

import React, { useState, useEffect } from "react";
import { ProgressBar } from "@carbon/react";
import { BULK_UPLOAD_GENERAL_TRANSLATIONS } from "../translations/util";

interface IProps {
  moduleName?: string;
  value?: number;
  max: number;
  status?: string;
  label?: string;
  helperText?: string;
  size?: number;
  running?: boolean;
  count?: number;
}
const LinearProgressBar = ({
  moduleName,
  value,
  max,
  status,
  label = BULK_UPLOAD_GENERAL_TRANSLATIONS.ProgressBar.dataProcessingLabelText,
  helperText,
  size,
  running,
  count,
}: IProps) => {
  return (
    <ProgressBar
      value={running ? count : null}
      max={max}
      status={count === max ? "finished" : "active"}
      label={
        count === max
          ? BULK_UPLOAD_GENERAL_TRANSLATIONS.ProgressBar.finshedLabelText
          : label
      }
      helperText={helperText}
      data-cy="progressBar"
    />
  );
};

export default LinearProgressBar;
